import styled from 'styled-components';

export const PopularTreatmentsContainer = styled.div`
  margin: 5rem 0;

  ${({ theme }) => theme.mediaQuery.lg} {
    margin: 8rem 0;
  }
`;

export const PopularTreatmentsWrapper = styled.div`
  max-width: ${({ theme }) => theme.layout.container};
  margin: 0 auto;
  padding: 0 2.4rem;
`;

export const PopularTreatmentsButton = styled.div`
  display: flex;
  justify-content: center;
`;

export const PopularTreatmentsSlider = styled.div`
  margin: 2rem 0 4rem 2.4rem;

  ${({ theme }) => theme.mediaQuery.xl} {
    margin: 8rem 0 8rem 8rem;
  }
`;
